import styled, { keyframes, useTheme } from 'styled-components';
import { FlexBox } from '@brg/ui';
import React, { forwardRef, lazy } from 'react';
// import { MapSearch } from 'brg-smap';
import { useTranslation } from 'react-i18next';
import { ApplicationShared } from '../../../core';

const MapSearch = lazy(() => import('brg-smap').then((module) => ({ default: module.MapSearch })));

export const FadeAnimation = keyframes`
  from {
    margin-right: -100vw;
  }
  to {
    margin-right: 0;
  }
`;

const SelectPointComponentWrapper = styled(FlexBox)`
    position: fixed;
    display: flex;
    width: 100%;
    top: 64px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1006;
    animation: 0.2s ease-in forwards ${FadeAnimation};
`;

const SelectPointComponentInner = styled(FlexBox)`
    background-color: ${(p) => p.theme.map.bg};
    width: 100%;
`;

const SelectPointComponentContent = styled(FlexBox)`
    background-color: ${(p) => p.theme.map.bg};
    margin-left: auto;
    margin-right: 40px;
    margin-top: 40px;
    width: calc(65% + 40px + 400px);
`;

const SelectPointClose = styled(FlexBox)`
    position: absolute;
    right: 44px;
    top: 8px;
    cursor: pointer;
    opacity: 0.8;
    transition: all 0.2s;
    &:hover {
        opacity: 1;
    }
`;

export interface PointValue {
    coords: string[];
    name: string;
    description: string;
    //pointId?: string;
    groupId?: string;
    tagName?: string;
    tagNameEn?: string;
}

export interface SelectPointComponentProps {
    onPointSelect?: (args: PointValue) => void;
    project?: PointValue;
}

export interface SelectPointRef {
    show(): void;
    hide(): void;
}

// eslint-disable-next-line react/display-name
export const SelectPointComponentNext = forwardRef(
    (props: SelectPointComponentProps, ref: React.Ref<SelectPointRef>) => {
        const [isVisible, setIsVisible] = React.useState(false);
        const theme = useTheme();
        const { i18n } = useTranslation();

        const show = (): void => {
            setIsVisible(true);
        };

        const hide = (): void => {
            setIsVisible(false);
        };

        React.useImperativeHandle(ref, () => ({
            show,
            hide,
        }));

        // нужно переписать mapsearch на зависимость от темы стайледов как появится время

        if (!isVisible) {
          return null
        }

        return (
            <SelectPointComponentWrapper>
                <SelectPointComponentInner>
                    <SelectPointComponentContent>
                        <MapSearch
                            initPointId={props.project}
                            onCancelClick={hide}
                            lang={i18n.language === 'ru' ? 'ru_RU' : 'en_US'}
                            onSearchClick={(coords: string, name: string, description: string) => {
                                props.onPointSelect?.({ coords: coords.split(' '), name, description });
                                hide();
                            }}
                            styleName={ApplicationShared.application === 'deziiign' ? 'white' : 'black'}
                        />
                    </SelectPointComponentContent>
                    <SelectPointClose onClick={hide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.582 11.9981L2.80484 19.7752L4.21905 21.1895L11.9962 13.4123L19.7752 21.1913L21.1895 19.7771L13.4105 11.9981L21.1896 4.2189L19.7754 2.80469L11.9962 10.5838L4.2189 2.8065L2.80469 4.22071L10.582 11.9981Z"
                                fill={theme.map.closeBtn}
                            />
                        </svg>
                    </SelectPointClose>
                </SelectPointComponentInner>
            </SelectPointComponentWrapper>
        );
    },
);
import styled, { keyframes, useTheme } from 'styled-components';
import { FlexBox } from '@brg/ui';
import React, { forwardRef, lazy } from 'react';
// import { MapSearch } from 'brg-smap';
import { useTranslation } from 'react-i18next';
import { ApplicationShared } from '../../../core';

const MapSearch = lazy(() => import('brg-smap').then((module) => ({ default: module.MapSearch })));

export const FadeAnimation = keyframes`
  from {
    margin-right: -100vw;
  }
  to {
    margin-right: 0;
  }
`;

const SelectPointComponentWrapper = styled(FlexBox)`
    position: fixed;
    display: flex;
    width: 100%;
    top: 64px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1006;
    animation: 0.2s ease-in forwards ${FadeAnimation};
`;

const SelectPointComponentInner = styled(FlexBox)`
    background-color: ${(p) => p.theme.map.bg};
    width: 100%;
`;

const SelectPointComponentContent = styled(FlexBox)`
    background-color: ${(p) => p.theme.map.bg};
    margin-left: auto;
    margin-right: 40px;
    margin-top: 40px;
    width: calc(65% + 40px + 400px);
`;

const SelectPointClose = styled(FlexBox)`
    position: absolute;
    right: 44px;
    top: 8px;
    cursor: pointer;
    opacity: 0.8;
    transition: all 0.2s;
    &:hover {
        opacity: 1;
    }
`;

export interface PointValue {
    coords: string[];
    name: string;
    description: string;
    //pointId?: string;
    groupId?: string;
    tagName?: string;
    tagNameEn?: string;
}

export interface SelectPointComponentProps {
    onPointSelect?: (args: PointValue) => void;
    project?: PointValue;
}

export interface SelectPointRef {
    show(): void;
    hide(): void;
}

// eslint-disable-next-line react/display-name
export const SelectPointComponentNext = forwardRef(
    (props: SelectPointComponentProps, ref: React.Ref<SelectPointRef>) => {
        const [isVisible, setIsVisible] = React.useState(false);
        const theme = useTheme();
        const { i18n } = useTranslation();

        const show = (): void => {
            setIsVisible(true);
        };

        const hide = (): void => {
            setIsVisible(false);
        };

        React.useImperativeHandle(ref, () => ({
            show,
            hide,
        }));

        // нужно переписать mapsearch на зависимость от темы стайледов как появится время

        if (!isVisible) {
          return null
        }

        return (
            <SelectPointComponentWrapper>
                <SelectPointComponentInner>
                    <SelectPointComponentContent>
                        <MapSearch
                            initPointId={props.project}
                            onCancelClick={hide}
                            lang={i18n.language === 'ru' ? 'ru_RU' : 'en_US'}
                            onSearchClick={(coords: string, name: string, description: string) => {
                                props.onPointSelect?.({ coords: coords.split(' '), name, description });
                                hide();
                            }}
                            styleName={ApplicationShared.application === 'deziiign' ? 'white' : 'black'}
                        />
                    </SelectPointComponentContent>
                    <SelectPointClose onClick={hide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.582 11.9981L2.80484 19.7752L4.21905 21.1895L11.9962 13.4123L19.7752 21.1913L21.1895 19.7771L13.4105 11.9981L21.1896 4.2189L19.7754 2.80469L11.9962 10.5838L4.2189 2.8065L2.80469 4.22071L10.582 11.9981Z"
                                fill={theme.map.closeBtn}
                            />
                        </svg>
                    </SelectPointClose>
                </SelectPointComponentInner>
            </SelectPointComponentWrapper>
        );
    },
);
